import { BoobleModalService } from 'booble-modal';
import { Component } from "@angular/core";

@Component({
    templateUrl: './contact-modal.component.html',
    styleUrls: ['./contact-modal.component.scss']
})
export class ContactModal { 

    constructor(private modalService: BoobleModalService) { }

    closeModal() {
        this.modalService.dismiss(null);
    }

}